import Divider from "@mui/material/Divider";

import SuiBox from "components/sui/SuiBox";
import SuiTypography from "components/sui/SuiTypography";

import { useTranslation } from "react-i18next";

import useDetectBreakpoint from "app/hooks/useDetectBreakPoint";

import colors from "assets/theme/base/colors";

function Separator() {
  const { t } = useTranslation();
  const bp = useDetectBreakpoint();

  return (
    <SuiBox position="relative" py={0.5}>
      <Divider />
      <SuiBox
        bgColor={bp === "xs" ? colors.background.default : "white"}
        position="absolute"
        top="50%"
        left="50%"
        px={1.5}
        lineHeight={1}
        sx={{ transform: "translate(-50%, -60%)" }}
      >
        <SuiTypography variant="button" fontWeight="medium" color="secondary">
          {t("or")}
        </SuiTypography>
      </SuiBox>
    </SuiBox>
  );
}

export default Separator;
